export enum WebSocketMessageTypeIncoming {
    PotlijnNotificationItems,
    WsSensorDataBool,
    WsSensorDataNumber,
    WsSensorsData,
    WsEspStatus,
    WsLogoSensorsData,
    WsLogosStatus,
    WsLogoOutputState,
    WsEspControlPowerResponce,
    WsEspControlResetResponce,
    WsTransputLoggings,
    WsRefreshWebPortalSetting,
    WsDevicesStatus,
}
